/**
 * Formatting duration helper function
 */
function FormatDuration(totalSeconds: number, defaultValue = 'N/A'): string {
  if (!totalSeconds || totalSeconds <= 0) {
    return defaultValue;
  }

  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    days && `${days} day${days > 1 ? '' : ''}`,
    hours && `${hours} hr${hours > 1 ? '' : ''}`,
    minutes && `${minutes} min${minutes > 1 ? '' : ''}`,
    seconds && `${seconds} sec${seconds > 1 ? '' : ''}`,
  ]
    .filter(Boolean)
    .join(' ');
}

export default FormatDuration;
